import { ziggyGetRoute as getRoute } from '@/router/ziggyGetRoute';
import { User } from "@/state/User";
import router from "@/router";

import { UserRoutes } from '@/repository/auth';
const { ShowUserWithTenants, GetUserOnTenant } = UserRoutes;

export default {
	namespaced: true,
	state: {
		current: User.stateDefaults(),
		_current: new User(),
	},
	actions: {
		async showUserWithTenants({ commit }) {
			try {
				let res = await ShowUserWithTenants()
				commit('SET_CURRENT_USER', res.data)
				return res.data
			}
			catch (error) {}
		},
		async showUserOnTenant({ commit }, tenantSlug) {
			try {
				let res = await GetUserOnTenant(tenantSlug)
				this.commit('tenant/SET_CURRENT_TENANT', res.data.current);
				commit('SET_CURRENT_USER', {
					coin_counts		: res.data.user_coins || {},
					current_tenant	: res.data.current || {},
					permissions		: res.data.permissions || {},
					role			: res.data.role || {}
				})
				return res.data;
			}
			catch (error) {
				router.push(getRoute('error', { type: (error.response || {}).status || 403 }))
			}
		}
	},
	mutations: {
		SET_CURRENT_USER(state, obj) {
			state.current = state._current.commit(obj)
		}
	}
}